import type { PedidoResponse } from '../store/MSCommerce/Pedidos/types';

const TIPOS_ENTREGA: Record<string, string> = {
  PUNTO_ENTREGA: 'Punto de entrega (entrega personal)',
  DOMICILIO: 'Envío a domicilio',
  NACIONAL: 'Envío nacional',
};

const ENTREGA_REQUIERE_COTIZACION = new Set(['DOMICILIO', 'NACIONAL']);

export const crearMensajePedidoWhatsapp = (pedido: PedidoResponse): string => {
  const codigo = `GS-${pedido.id.slice(0, 8).toUpperCase()}`;
  const abono = pedido.pagos
    .filter(pago => pago.status === 'EN_REVISION' || pago.status === 'APROBADO')
    .reduce((total, pago) => total + (pago.montoPagado ?? 0), 0);
  const pendiente = Math.max(0, Math.round((pedido.total - abono) * 100) / 100);
  const entrega = pedido.entrega;
  const costoEnvio = entrega?.costoEnvio ?? 0;
  const envioPorConfirmar = Boolean(
    entrega &&
    ENTREGA_REQUIERE_COTIZACION.has(entrega.tipo) &&
    costoEnvio <= 0
  );
  const lineas = [
    `Hola, quiero preguntar sobre mi pedido ${codigo}:`,
    ...pedido.detalles.map(d => `- ${d.nombreProducto} x${d.cantidad}`),
    '',
  ];

  if (envioPorConfirmar) {
    lineas.push(
      `Total de productos: $${pedido.total.toFixed(2)}`,
      'Costo de envío: Por confirmar según la dirección y la ciudad. Lo coordinaremos por WhatsApp.',
      `Abono reportado: $${abono.toFixed(2)}`,
      `Pendiente de productos: $${pendiente.toFixed(2)}`,
      'El costo de envío se añadirá después de coordinarlo.'
    );
  } else {
    lineas.push(`Total: $${pedido.total.toFixed(2)}`);
    if (costoEnvio > 0) lineas.push(`Costo de envío: $${costoEnvio.toFixed(2)}`);
    lineas.push(
      `Abono reportado: $${abono.toFixed(2)}`,
      `Pendiente de pago: $${pendiente.toFixed(2)}`
    );
  }

  if (entrega) {
    lineas.push('', `Forma de entrega: ${TIPOS_ENTREGA[entrega.tipo] ?? entrega.tipo}`);
    if (entrega.ciudad) lineas.push(`Ciudad: ${entrega.ciudad}`);
    if (entrega.direccion) lineas.push(`Dirección: ${entrega.direccion}`);
    if (entrega.referencia) lineas.push(`Referencia: ${entrega.referencia}`);
    if (entrega.contactoNombre) lineas.push(`Contacto: ${entrega.contactoNombre}`);
    if (entrega.contactoPhone) lineas.push(`Teléfono: ${entrega.contactoPhone}`);
  }

  return encodeURIComponent(lineas.join('\n'));
};
